/* eslint-disable import/no-unresolved */
import React, { Component } from "react";
import { arrayOf, bool, shape, func, string } from "prop-types";

import Button from "pages/_components/Button";
import Container from "pages/_components/Container";
import classNames from "classnames";

const getChipBackgroundColor = (isSelected, useTransparentContainer) => {
    if (isSelected) {
        return "#f2f8fd";
    }
    if (useTransparentContainer) {
        return "#fff";
    }
    return "";
};

class TabletSelectors extends Component {
    static propTypes = {
        possibleOptions: arrayOf(shape({})).isRequired,
        isDesktop: bool.isRequired,
        optionSelected: shape({}).isRequired,
        changeOption: func.isRequired,
        section: string,
        containerClass: string,
        buttonClass: string,
        buttonContainerClass: string,
        imageClassName: string,
        buttonsWrapperClassNames: string,
        centerButtons: bool,
        leftButtons: bool,
        allDisabled: bool,
        transparentBackground: bool,
    };

    static defaultProps = {
        section: "",
        containerClass: "",
        buttonClass: "",
        buttonContainerClass: "",
        imageClassName: "",
        buttonsWrapperClassNames: "",
        centerButtons: false,
        leftButtons: false,
        allDisabled: false,
        transparentBackground: false,
    };

    render() {
        const {
            isDesktop,
            possibleOptions,
            optionSelected,
            changeOption,
            section,
            containerClass,
            buttonClass,
            buttonContainerClass,
            centerButtons,
            leftButtons,
            imageClassName,
            allDisabled,
            buttonsWrapperClassNames,
            transparentBackground,
        } = this.props;

        return (
            <Container
                className={classNames("flex-grow align-items-center", containerClass, {
                    "bg-white": !transparentBackground,
                })}
                rowClassName={section === "MovementsFinancing" && "justify-content-start"}>
                <div
                    className={classNames("d-flex flex-wrap", buttonsWrapperClassNames, {
                        "justify-content-center px-2 gap-1 w-100": !isDesktop,
                        "justify-content-center": (!isDesktop || centerButtons) && !leftButtons,
                        "gap-1": isDesktop && section !== "metrocorp",
                        "justify-content-center gap-2": isDesktop && section === "metrocorp",
                        "w-100": isDesktop && section === "transfer",
                    })}>
                    {possibleOptions.map((option) => {
                        const isSelected = optionSelected === option.value;
                        return (
                            <div className={classNames("tablet-selector-button", buttonContainerClass)}>
                                <Button
                                    disabled={allDisabled || option.disabled}
                                    className={classNames("btn-regular chip-selector-btn rounded-full", buttonClass)}
                                    bsStyle="outline"
                                    block={false}
                                    imageStyle={`m-0 ${imageClassName}`}
                                    image={isSelected ? "images/check.svg" : ""}
                                    style={{
                                        backgroundColor: getChipBackgroundColor(isSelected, transparentBackground),
                                        borderColor: isSelected ? "#0071ce" : "#ccc",
                                        color: isSelected ? "#0071ce" : "#666",
                                    }}
                                    onClick={() => changeOption(option.value)}
                                    label={option.label}
                                />
                            </div>
                        );
                    })}
                </div>
            </Container>
        );
    }
}

export default TabletSelectors;
